import { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useReservation } from '@repo/domain-service';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export default function ReservationExistsGuard() {
  const { id } = useParams<{ id: string }>();
  const { reservation, loadingReservation } = useReservation(id!);
  const navigate = useNavigate();

  useEffect(() => {
    if (!id || (!loadingReservation && !reservation)) {
      navigate(ROUTE_PATHS[RouteName.ACCOUNT_RESERVATIONS], { replace: true });
    }
  }, [id, loadingReservation, reservation, navigate]);

  if (!reservation) {
    return null;
  }

  return <Outlet context={reservation} />;
}
